import create from "zustand";

const useBrandStore = create((set) => ({
  isListChanged: false,
  refreshBrandList: () =>
    set((state) => ({ isListChanged: !state.isListChanged })),
}));

export default useBrandStore;
